import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import LicenseAgreementText from "./LicenseAgreementText";
import { useOptInStore } from "./store/optInStore";

const formatDate = (ms) => (ms ? new Date(ms).toLocaleString() : null);

const LicenseAgreementDialog = ({ open, onClose }) => {
  const license = useOptInStore((state) => state.license);
  const fetchLicenseStatus = useOptInStore((state) => state.fetchLicenseStatus);

  useEffect(() => {
    if (open) fetchLicenseStatus();
  }, [open, fetchLicenseStatus]);

  const agreement = license?.agreement;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle sx={{ color: "#2F3F5C" }}>
        {agreement?.title || "License Agreement"}
        {license?.accepted_at && (
          <Typography variant="caption" component="div" color="text.secondary">
            Version {agreement?.version || "—"} · accepted {formatDate(license.accepted_at)}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            backgroundColor: "#f8f8f8",
            border: "1px solid #ddd",
            borderRadius: 1,
            p: 2,
          }}
        >
          <LicenseAgreementText agreement={agreement} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LicenseAgreementDialog;
